import { PlusIcon } from 'lucide-react';
import { Link } from 'react-router';

import { cn } from '@/lib/utils';

export function IntranetComposeFab({
  writeHref,
  className,
}: {
  writeHref: string;
  className?: string;
}) {
  return (
    <Link
      to={writeHref}
      aria-label="Beitrag schreiben"
      className={cn(
        'fixed right-4 z-40 inline-flex size-14 items-center justify-center rounded-full bg-brand-red text-white shadow-lg',
        'hover:bg-brand-red/90 focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:outline-none lg:hidden',
        'bottom-[calc(4.75rem+env(safe-area-inset-bottom))]',
        className,
      )}
    >
      <PlusIcon className="size-7" strokeWidth={2.5} aria-hidden />
    </Link>
  );
}
